export const floatRegex = /^\d*\.?\d*$/;
export const integerRegex = /^\d+$/;
export const wordRegex = /^[A-Za-zА-Яа-яЁё]+$/;